import { render, staticRenderFns } from "./InProgressMissions.vue?vue&type=template&id=15464c5c&"
import script from "./InProgressMissions.vue?vue&type=script&lang=ts&setup=true&"
export * from "./InProgressMissions.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports